// Load .env vars into the config

const formattedVars: { [key: string]: string } = {};

for (const [key, value] of Object.entries(import.meta.env)) {
  if (value === undefined) {
    continue;
  }
  formattedVars[key.replace('VITE_', '').toLowerCase()] = String(value);
}

type Config = {
  [key: string]: string;
};

const config: Config = {
  ...formattedVars,
  ...{
    // Add app config/constants here that you do not want in the .env files
    application_name: 'Opendock Photon',
    environment: import.meta.env.MODE === 'production' ? 'production' : 'development'
  }
};

export default config;
